// Firebase Analytics integration for the chat widget.
// Reports to GA4 measurement id G-QRMV0YRF8Y (Firebase project's auto-linked
// Analytics property). Events propagate to GA4 within minutes and are
// also visible in Firebase Console > Analytics.
//
// All event names are snake_case and prefixed `chat_` for filtering.
// All calls are best-effort - ad blockers will silently drop them.

import { initializeApp, type FirebaseApp } from 'firebase/app';
import { getAnalytics, logEvent, type Analytics } from 'firebase/analytics';

// Public Firebase web SDK config. apiKey is a public identifier (locked down
// by Firebase security rules and HTTP referrer restrictions, not a secret).
const firebaseConfig = {
  apiKey: 'AIzaSyDcq-1TPqq8qTygezO6EUFutH4O37wgRTw',
  authDomain: 'co-bmec-bme049-prod.firebaseapp.com',
  projectId: 'co-bmec-bme049-prod',
  storageBucket: 'co-bmec-bme049-prod.firebasestorage.app',
  messagingSenderId: '512763259512',
  appId: '1:512763259512:web:757f91a9672f45e428db8d',
  measurementId: 'G-QRMV0YRF8Y',
};

let _app: FirebaseApp | null = null;
let _analytics: Analytics | null = null;
let _failed = false;

function getInstance(): Analytics | null {
  if (_analytics) return _analytics;
  if (_failed) return null;
  try {
    if (!_app) _app = initializeApp(firebaseConfig);
    _analytics = getAnalytics(_app);
    return _analytics;
  } catch {
    _failed = true;
    return null;
  }
}

export function track(event: string, params?: Record<string, unknown>): void {
  const a = getInstance();
  if (!a) return;
  try {
    logEvent(a, event, params as Record<string, string | number | boolean | undefined>);
  } catch {
    // analytics failures must never break the widget
  }
}

// Pre-warm: trigger init on module load so the first track() call doesn't pay
// the SDK boot cost. Wrapped in try so SSR or restricted contexts can't trip.
try {
  getInstance();
} catch {
  // noop
}
